import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faShoppingCart, faInfo, faFileInvoice, faGear } from '@fortawesome/free-solid-svg-icons';
import { SubscriptionListModel } from 'src/app/models/subscriptionList.model';
import { SubscriptionService } from '../subscription.service';

@Component({
  standalone: false,
  selector: 'app-my-subscriptions',
  templateUrl: './my-subscriptions.component.html',
  styleUrls: ['./my-subscriptions.component.css']
})
export class MySubscriptionsComponent {
  model: SubscriptionListModel[];
  faShoppingCart = faShoppingCart;
  faInfo = faInfo;
  faFileInvoice = faFileInvoice;
  faGear = faGear;

  constructor(private activatedRoute: ActivatedRoute, private subscriptionService: SubscriptionService) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({ subscriptionData }) => {
      this.model = subscriptionData;
    })
  }

  onManageSubscription() {
    this.subscriptionService.getCustomerPortalSession().subscribe({
      next: (response: any) => {
        window.location.href = response.portalUrl;
      },
      error: (err) => {
        console.error('Failed to open customer portal', err);
      }
    });
  }
}
